import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width={234.5}
    height={198}
    viewBox="0 0 234.5 198"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <path
          className="cls-1"
          d="M150.3,79.7c-.2,6.8-5.3-5.6-12.1-5.8-6.8-.2-12.6,11.8-12.4,5,.2-6.8,5.9-12.1,12.6-11.9,6.8.2,12.1,5.9,11.9,12.6Z"
        />
        <path
          className="cls-1"
          d="M233.8,79.3c-1.4-6.6-5.2-12.8-9.3-18.3,0,0-13.8-33.5-32.2-44C173.9,6.4,120.8.4,120.8.4c-12.7-2.2-46.2,4.7-56.4,7.8-20.4,4.2-33.7,19.8-44.2,36.7C3.3,72.2-3.7,103.7,1.9,134.3c3.2,17.2,11.9,31.3,26.5,42.5,12.1,9.3,41.2,26.3,48.1,19.7,5.7-5.5-1.6-21.8-6.1-32.1-6.3-14.2-13-28.3-11.8-42.1-1.1-6.5-.3-13.5,1.1-19.9-.1-.4-.2-.7-.4-1.1-.9-2.9-1.2-5-3.9-6.5-.5-.3-1-.9-1.4-1.6-1.8-3-5.9-3.7-8.6-1.5-6.8,5.5-10.6,14-13.6,17.5-3.3,3.9-8.5,5.7-6.9-4.4,0-.3,1.4-4.6,1.5-4.9,3.1-10.9,4.3-18.3,9.6-28.3,5.1-9.6,8.5-15.8,15.6-24.1,1.7-1.9,9-3.7,10.7-2.6,4.7,1.3,8.1,5.1,11.6,8.5,2.1,2,4,4.1,5.8,6.3,1-1.7,2.2-3.4,3.8-4.7,6-12.8,36.6-16.7,58.2-11.8,18.5,4.2,19.5,19.2,39.6,25.6,10.1,3.2,26.5,6.7,31.1,4.3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1.5-.2,1.6-.2.2,0,.2,0,.6-.2,2.2,1.1,4,2.6,5,4.5-.1,1-.1,2,0,3-8.3,15.9-7.3,35.1-21.2,41.5-16,7.8-30.2.5-40,8.8-16.7,14.1-23.5,32.2-18,51.8,3.2,11.1,14.6,15.7,26.7,12.1,13.6-4,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.3,4.6-21.1,5.6-31.8.6-6.7,1.6-13.5.2-20.1Z"
        />
      </g>
    </g>
  </svg>
);
export default SVGComponent;
